import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import { AuthProvider } from './context/AuthProvider'

//window.SERVER_APP_API_PHP = 'https://www.real-estate.kanchtech.com' //server files
//window.SERVER_APP_API_PHP = 'https://www.orthopraxyministries.com/real-estate'
window.SERVER_APP_API_PHP = 'https://www.kanchinnotech.nl/real-estate'
window.SERVER_APP_API = 'https://www.kanchinnotech.nl/real-estate'

let business_locationIDMain = localStorage.getItem('business_locationIDMain')
if(business_locationIDMain === null){
  business_locationIDMain = '';
}
window.business_locationIDMain = business_locationIDMain;
console.log('Business Location ID Main', business_locationIDMain);

let userCompanyID = localStorage.getItem('companyID')
if(userCompanyID === 'Admin'){
 userCompanyID = 1;
}
window.userCompanyID = userCompanyID

let userID = localStorage.getItem('userID')
if(userID === 'Admin'){
  userID = 1;
}
window.userID = JSON.parse(userID)

let userEmail = localStorage.getItem('email')
if(userEmail === 'Admin'){
  userEmail = "";
}
window.userEmail = userEmail;

let userType = localStorage.getItem('userType')
if(userType === 'Admin'){
  userType = "";
}
window.userType = userType;



const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route path='/*' element={<App />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
